import React from "react";
import "../styles/Footer.css";
import githubPic from "../images/portfolio/github.png";
const Footer = () => {
  return (
    <footer>
      <p>xeyal.isaxnaov@gmail.com</p>
      <div className="github">
        <a href="https://github.com/xeyal-i/">Github</a>
      </div>
    </footer>
  );
};

export default Footer;
